import { VehicleReturnService } from "@App/apis/graphql/vehicleReturn/v1/VehicleReturnService";
import type { PickUpAddress } from "@App/state/reducers/vehicleReturn";
import type { ContractDetails } from "@App/types";
import { useState } from "react";

export function useReturnSubmit(
  organizationId: number,
  contractDetails: ContractDetails,
  pickupAddress: PickUpAddress,
  returnDates: Date[],
  onSubmit: () => void,
) {
  const service = new VehicleReturnService();

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  async function handleSubmit() {
    setLoading(true);
    setError(false);
    try {
      const res = await service.createVehiclePickup({
        organizationId,
        payload: {
          carId: contractDetails.carId,
          name: pickupAddress.name,
          street: pickupAddress.street,
          postcode: pickupAddress.postcode,
          city: pickupAddress.city,
          country: contractDetails.country,
          email: pickupAddress.email,
          customerAgreedToPaidPickup: true,
          dates: returnDates,
          phone: pickupAddress.phone,
        },
      });
      if (!res.ok) {
        setError(true);
        return;
      }
      onSubmit();
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  return {
    loading,
    error,
    handleSubmit,
  };
}
